import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.map.js";
import React from 'react';
import FontAwesome from 'react-fontawesome';
import { RenderQuestionErrorWrapper } from "../style";
var ErrorBlock = function ErrorBlock(_ref) {
  var errors = _ref.errors;
  if (!errors || !Array.isArray(errors) || errors.length <= 0) return null;
  return /*#__PURE__*/React.createElement(RenderQuestionErrorWrapper, null, /*#__PURE__*/React.createElement(FontAwesome, {
    name: "exclamation-circle"
  }), errors.map(function (_ref2, idx) {
    var title = _ref2.title,
      detail = _ref2.detail;
    return /*#__PURE__*/React.createElement("div", {
      key: idx
    }, title, ": ", detail);
  }));
};
export default ErrorBlock;